
<template>
  <div class="authorItem">
    <p>
      认证信息提示:请确保上传的信息真实有效，防止认证失败，感谢您的配合！
    </p>
    <div class="item auItem1" v-show="aulist.au1">
      <el-radio v-model="radio" label="1">个人认证</el-radio>
      <br>
      <br>
      <el-radio v-model="radio" label="2">企业认证</el-radio>
    </div>
    <div class="item auItem2" v-show="aulist.au2">
      <el-form :model="userItem" ref="userForm" :disabled="userDisabled" :rules="userRule" label-width="90px" class="userForm">
        <el-form-item label="真实姓名" prop="trueName">
          <el-input v-model="userItem.trueName" placeholder="真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="cardNO">
          <el-input v-model="userItem.cardNO" placeholder="身份证号"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="tel">
          <el-input ref="tel" v-model="userItem.tel" placeholder="手机号码"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="validateCode" v-show="!userDisabled">
          <el-input v-model="userItem.validateCode" placeholder="手机验证码" class="vcode"></el-input>
          <span v-show="sendAuthCode" class="auth_text auth_text_blue"  @click="getAuthCode">获取验证码</span>
          <span v-show="!sendAuthCode" class="auth_text"> <span class="auth_text_blue">{{auth_time}}秒后再获取</span></span>
        </el-form-item>
      </el-form>
    </div>
    <div class="item auItem3" v-show="aulist.au3">
      <el-form :model="comItem" ref="comForm" :rules="comRule" :disabled="comDisabled" label-width="110px" class="userForm">
        <el-form-item label="公司名称" prop="company_name">
          <el-input v-model="comItem.company_name" placeholder="公司名称"></el-input>
        </el-form-item>
        <el-form-item label="法人姓名" prop="legal_name">
          <el-input v-model="comItem.legal_name" placeholder="法人姓名"></el-input>
        </el-form-item>
        <el-form-item label="法人身份证号" prop="legal_idcard">
          <el-input v-model="comItem.legal_idcard" placeholder="法人身份证号码"></el-input>
        </el-form-item>
        <el-form-item label="组织机构代码" prop="org_code">
          <el-input v-model="comItem.org_code" placeholder="组织机构代码"></el-input>
        </el-form-item>
        <el-form-item label="营业执照号" prop="bus_license">
          <el-input v-model="comItem.bus_license" placeholder="营业执照号"></el-input>
        </el-form-item>
        <el-form-item label="营业执照上传" prop="bus_license_pic">
          <el-upload
            class="avatar-uploader"
            action="/dmc/file/uploadFile"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload><span class="pic-text">选择上传文件</span>
        </el-form-item>
      </el-form>
    </div>
    <div class="center">
      <el-button type="danger" class="btn-reg" @click="submitForm" plain v-show="aulist.au1">确认</el-button>
      <el-button type="danger" class="btn-reg" @click="submitUserForm" plain v-show="aulist.au2" v-if="!userDisabled">确认</el-button>
      <el-button type="danger" class="btn-reg" @click="submitComForm" plain v-show="aulist.au3" v-if="!comDisabled">确认</el-button>
    </div>
  </div>
</template>

<script>
import eventBus from '../../common/eventBus.js'
export default {
  name: 'account',
  props: ['authType'],
  data () {
    var vCodeValidator = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else {
        let queryParam = { vCode: value }
        this.sapost('/dmc/account/unique', queryParam, r => {
          let result = r.data
          if (result.retCode === '1') {
            callback(new Error('验证码输入有误'))
          } else {
            callback()
          }
        })
      }
    }
    var imageValidator = (rule, value, callback) => {
      if (this.imageUrl === '') {
        callback(new Error('请上传营业执照'))
      } else {
        callback()
      }
    }
    return {
      radio: '1',
      userItem: {
        trueName: '',
        cardNO: '',
        tel: '',
        validateCode: ''
      },
      userDisabled: false,
      comDisabled: false,
      comItem: {
        id: '',
        company_name: '',
        legal_name: '',
        legal_idcard: '',
        org_code: '',
        bus_license: '',
        bus_license_name: '',
        status: ''
      },
      imageUrl: '',
      aulist: {
        au1: true,
        au2: false,
        au3: false
      },
      sendAuthCode: true,
      auth_time: 0,
      userRule: {
        trueName: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
          { pattern: /^[\u0391-\uFFE5]+$/, message: '请输入中文' }
        ],
        cardNO: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { pattern: /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[A-Z])$/, message: '请输入正确的身份证号' }
        ],
        tel: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
        ],
        validateCode: [
          { required: true, message: '请输入手机验证码', trigger: 'blur' },
          { validator: vCodeValidator }
        ]
      },
      comRule: {
        company_name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        legal_name: [
          { required: true, message: '请输入法人姓名', trigger: 'blur' }
        ],
        legal_idcard: [
          { required: true, message: '请输入法人身份证号', trigger: 'blur' },
          { pattern: /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[A-Z])$/, message: '请输入正确的身份证号' }
        ],
        org_code: [
          { required: true, message: '请输入组织机构代码', trigger: 'blur' }
        ],
        bus_license: [
          { required: true, message: '请输入营业执照号', trigger: 'blur' }
        ],
        bus_license_pic: [
          { validator: imageValidator }
        ]
      }
    }
  },
  computed: {
  },
  methods: {
    submitForm () {
      if (this.radio === '1') {
        this.aulist.au1 = false
        this.aulist.au2 = true
        this.aulist.au3 = false
        this.$emit('changeTitle', '个人认证')
        // 查询用户信息
        this.sapost('/dmc/account/account', '', r => {
          let {retCode, e} = r.data
          if (retCode === '0') {
            // 认证信息提交过
            if (e.authStatus !== '0') {
              // 显示已经提交过的信息
              this.userItem.trueName = e.trueName
              this.userItem.cardNO = e.cardNO
              this.userItem.tel = e.tel
              // 如果是待审核和已通过的状态禁止用户编辑
              if (e.authStatus === '1' || e.authStatus === '2') {
                this.userDisabled = true
              } else {
                this.userDisabled = false
              }
            }
          }
        })
      } else {
        this.aulist.au1 = false
        this.aulist.au2 = false
        this.aulist.au3 = true
        this.$emit('changeTitle', '企业认证')
        // 查询企业认证信息
        var _this = this
        this.sapost('/dmc/account/authComInfo', '', r => {
          let {retCode, authComInfo} = r.data
          if (retCode === '0') {
            // 显示已经提交过的信息
            this.comItem = authComInfo

            // 查询图片信息
            _this.$http.get('/dmc/account/getImage', {
              params: {
                id: this.comItem.id
              },
              responseType: 'arraybuffer'
            }).then(function (response) {
              // 将从后台获取的图片流进行转换
              return 'data:image/png;base64,' + btoa(
                new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
              )
            }).then(function (data) {
              // 接收转换后的Base64图片
              _this.imageUrl = data
            })
            // 如果是待审核和已通过的状态禁止用户编辑
            if (authComInfo.status === '1' || authComInfo.status === '2') {
              this.comDisabled = true
            } else {
              this.comDisabled = false
            }
          }
        })
      }
    },
    submitUserForm() {
      this.$refs.userForm.validate(valid => {
        if (valid) {
          // this.$refs.comForm.submit()
          let account = JSON.stringify(this.userItem)
          this.$http({
            method: 'post',
            url: '/dmc/account/authAccount',
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: account
          }).then(r => {
            let { retMsg, retCode } = r.data
            if (retCode === '0') {
              this.$emit('closeDialog')
              this.$message.success(retMsg)
            } else {
              this.$message.warning(retMsg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitComForm() {
      this.$refs.comForm.validate(valid => {
        if (valid) {
          let authCom = JSON.stringify(this.comItem)
          this.$http({
            method: 'post',
            url: '/dmc/account/authCom',
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: authCom
          }).then(r => {
            let { retMsg, retCode } = r.data
            if (retCode === '0') {
              this.$emit('closeDialog')
              this.$message.success(retMsg)
            } else {
              if (retMsg === '用户未登录！') {
                eventBus.$emit('logout')
              }
              this.$message.warning(retMsg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
      this.comItem.bus_license_name = res.fileName
      this.comItem.status = res.realPath
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    getAuthCode() {
      if (this.userItem.tel === '') {
        this.$refs.tel.focus()
        return
      }
      this.sendAuthCode = false
      this.auth_time = 60
      var authTimetimer = setInterval(() => {
        this.auth_time--
        if (this.auth_time <= 0) {
          this.sendAuthCode = true
          clearInterval(authTimetimer)
        }
      }, 1000)
      // 发送短信验证码接口
      let query = { phone: this.userItem.tel }
      var _this = this
      this.sapost('/dmc/account/getPhoneCode', query, r => {
        let msg = r.data.msg
        if (msg === 'success') {
          console.log('短信验证码发送成功')
          setTimeout(function () {
            _this.sapost('/dmc/account/removeValidateCode', '', r => {
              console.log(r.data.msg)
            })
          }, 90 * 1000)
        } else {
          console.log('短信验证码发送失败')
        }
      })
    }

  },
  watch: {
    authType(val) {
      if (val) {
        this.radio = '1'
        this.aulist.au1 = true
        this.aulist.au2 = false
        this.aulist.au3 = false
        this.$refs.userForm.resetFields()
        this.$refs.comForm.resetFields()
        this.imageUrl = ''
      }
    }
  }
}
</script>

<style lang="less">
.authorItem{
  position: relative;
  p{
    padding: 0 15px;
    border-top:1px solid #ddd;
    text-align: justify;
  }
  .item{
    padding: 0px 20px 10px;
    border-bottom:1px solid #ddd;
    min-height: 110px;
    margin-bottom: 10px;
  }
  .auItem1{
    padding: 30px;
    .el-radio__input.is-checked .el-radio__inner{
      border-color: rgb(241, 137, 129);
      background: #fff;
    }
    .el-radio__inner::after{
      background-color: rgb(241, 137, 129);
    }
    .el-radio__inner {
      border: 1px solid#999;
    }
    .el-radio__label{
      color: #333;
    }
  }
  .auItem3{
    padding-top: 10px;
    .el-form-item__label{
      text-align: left;
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      float: left;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 148px;
      height: 108px;
      line-height: 108px;
      text-align: center;
    }
    .avatar {
      width: 148px;
      height: 108px;
      display: block;
    }
    .el-form-item{
      margin-bottom: 22px;
    }
    .pic-text{
      margin-left: 10px;
      color: red;
      font-size: 12px;
      vertical-align: bottom;
      display: inline-block;
      margin-top: 72px;
    }
  }
  .auItem2{
    padding-top: 10px;
    .el-form-item__label{
      text-align: left;
    }
    .vcode{
      width: 50%;
      input{
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    span{
      display: inline-block;
      width: 100px;
      height: 40px;
      background-color: #f55d54;
      text-align: center;
      vertical-align: bottom;
      cursor: pointer;
    }
  }
  .center{
    text-align: center;
    .el-button--danger.is-plain:focus{
      background-color: #fef0f0;
      border-color: #fbc4c4;
      color: #F56C6C;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/userCenter/authorItem.vue